exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-append {\n  background-color: #fff !important;\n  border-left: none;\n}\n", ""]);

// exports
